import { IPcr } from '../../../features/pcr/store/pcr.types'
import { IPainScales, IPatientVitals } from '../../../features/vitals/store/vitals.types'
import Logger from '../../../services/logger.service'
import { setValueForPathWithCreate } from '../../object.util'

export const addPainScale = (pcr: any): IPcr => {
  try {
    if (pcr.patient && pcr.patient.patientVitals?.length && pcr.patient.patientVitals[0].painScales === undefined) {
      pcr.patient.patientVitals.forEach((vital: IPatientVitals & { painScales?: IPainScales }) => {
        setValueForPathWithCreate(vital, 'painScales', {
          totalsCombined: '',
          painScaleSelections: [],
        })
      })
    }
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule addPainScale: ${error}`)
    throw error
  }
}
